package com.taocent.simple.compose.component.richtext.core.internal.ui

import androidx.compose.ui.input.key.Key
import androidx.compose.ui.input.key.KeyEvent
import androidx.compose.ui.input.key.KeyEventType
import androidx.compose.ui.input.key.isCtrlPressed
import androidx.compose.ui.input.key.isMetaPressed
import androidx.compose.ui.input.key.isShiftPressed
import androidx.compose.ui.input.key.key
import androidx.compose.ui.input.key.type
import com.taocent.simple.compose.component.richtext.core.RichTextState
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.launch

fun handleRichTextKeyEvent(
    event: KeyEvent,
    state: RichTextState,
    clipboardActions: RichTextClipboardActions,
    coroutineScope: CoroutineScope,
    allowSmartPaste: Boolean,
    dispatchRegisteredCommands: Boolean = false,
    onUndo: (() -> Unit)? = null,
    onRedo: (() -> Unit)? = null,
): Boolean {
    if (dispatchRegisteredCommands && state.keyCommands.dispatch(event)) return true
    if (event.type != KeyEventType.KeyDown) return false
    val isModifierPressed = event.isCtrlPressed || event.isMetaPressed
    if (!isModifierPressed) return false
    return when (event.key) {
        Key.Z -> {
            if (event.isShiftPressed) {
                onRedo?.invoke() ?: state.redo()
            } else {
                onUndo?.invoke() ?: state.undo()
            }
            true
        }
        Key.Y -> {
            onRedo?.invoke() ?: state.redo()
            true
        }
        Key.C -> {
            coroutineScope.launch { clipboardActions.copySelection() }
            true
        }
        Key.X -> {
            coroutineScope.launch { clipboardActions.cutSelection() }
            true
        }
        Key.V -> {
            // 标记"下一次 BasicTextField 的 onValueChange 是 native paste 触发的"。
            // 顶层 Cmd/Ctrl+V 拦截器(或本函数被直接调用)主动 paste 之后,
            // BasicTextField 内部原生 paste event 随后会触发 onValueChange 插入
            // plain text,如果不阻止就会与 paste 路径叠加变成「A[无样式]A[有样式]」。
            // RichTextState.onValueChange 检测到 flag 后直接 return,跳过
            // textEditor.onValueChange,避免重复插入。
            state.markSuppressedImePasteOnNextValueChange()
            coroutineScope.launch { clipboardActions.paste(allowSmartPaste = allowSmartPaste) }
            true
        }
        else -> false
    }
}
